import { render } from "./Utenti.vue?vue&type=template&id=2f99854f"
import script from "./Utenti.vue?vue&type=script&lang=js"
export * from "./Utenti.vue?vue&type=script&lang=js"
script.render = render

export default script